var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleOldMemberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.71094,
    y: 0.380859,
    width: 8.40678,
    height: 4.20339,
    fill: "#190D11"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.71094,
    y: 4.58398,
    width: 8.40678,
    height: 8.40678,
    fill: "#BDB69F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1523,
    y: 55.0254,
    width: 8.40678,
    height: 4.20339,
    fill: "#BDB69F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 59.3555,
    y: 59.2285,
    width: 8.40678,
    height: 4.20339,
    fill: "#BDB69F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5586,
    y: 63.4316,
    width: 8.40678,
    height: 4.20339,
    fill: "#BDB69F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1172,
    y: 4.58398,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1172,
    y: 8.78711,
    width: 4.20339,
    height: 8.40678,
    fill: "#767266"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9492,
    y: 46.6182,
    width: 4.20339,
    height: 12.6102,
    fill: "#767266"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 59.3555,
    y: 50.8213,
    width: 4.20339,
    height: 12.6102,
    transform: "rotate(90 59.3555 50.8213)",
    fill: "#767266"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7266,
    y: 21.3975,
    width: 4.20339,
    height: 8.40678,
    fill: "#767266"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3398,
    y: 34.0078,
    width: 4.20339,
    height: 8.40678,
    fill: "#767266"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 8.91406,
    y: 12.9912,
    width: 4.20339,
    height: 4.20339,
    fill: "#767266"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5234,
    y: 25.6016,
    width: 4.20339,
    height: 4.20339,
    fill: "#767266"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 38.2109,
    width: 4.20339,
    height: 4.20339,
    fill: "#767266"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3203,
    y: 12.9912,
    width: 4.20339,
    height: 4.20339,
    fill: "#87480D"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1172,
    y: 17.1943,
    width: 4.20339,
    height: 4.20339,
    fill: "#87480D"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3398,
    y: 42.415,
    width: 4.20339,
    height: 4.20339,
    fill: "#87480D"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 8.91406,
    y: 29.8047,
    width: 4.20339,
    height: 4.20339,
    fill: "#87480D"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7266,
    y: 38.2109,
    width: 4.20339,
    height: 4.20339,
    fill: "#87480D"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 42.543,
    y: 21.3975,
    width: 4.20339,
    height: 4.20339,
    fill: "#87480D"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1523,
    y: 34.0078,
    width: 4.20339,
    height: 4.20339,
    fill: "#87480D"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3203,
    y: 8.78711,
    width: 8.40678,
    height: 4.20339,
    fill: "#190D11"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 4.71094,
    y: 12.9912,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 8.91406,
    y: 34.0078,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3203,
    y: 38.2109,
    width: 4.20339,
    height: 8.40678,
    fill: "#190D11"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5234,
    y: 38.2109,
    width: 4.20339,
    height: 8.40678,
    fill: "#BF6717"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3203,
    y: 25.6016,
    width: 4.20339,
    height: 8.40678,
    transform: "rotate(90 17.3203 25.6016)",
    fill: "#BF6717"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 8.78711,
    width: 4.20339,
    height: 4.20339,
    transform: "rotate(90 34.1328 8.78711)",
    fill: "#BF6717"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 42.543,
    y: 21.3975,
    width: 4.20339,
    height: 4.20339,
    transform: "rotate(90 42.543 21.3975)",
    fill: "#BF6717"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1523,
    y: 34.0078,
    width: 4.20339,
    height: 4.20339,
    transform: "rotate(90 55.1523 34.0078)",
    fill: "#BF6717"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 42.543,
    y: 50.8213,
    width: 4.20339,
    height: 4.20339,
    transform: "rotate(90 42.543 50.8213)",
    fill: "#BF6717"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 42.543,
    y: 25.6016,
    width: 4.20339,
    height: 4.20339,
    transform: "rotate(90 42.543 25.6016)",
    fill: "#F89202"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1523,
    y: 38.2109,
    width: 4.20339,
    height: 4.20339,
    transform: "rotate(90 55.1523 38.2109)",
    fill: "#F89202"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5234,
    y: 21.3975,
    width: 4.20339,
    height: 8.40678,
    transform: "rotate(90 21.5234 21.3975)",
    fill: "#F89202"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 34.0078,
    width: 4.20339,
    height: 8.40678,
    transform: "rotate(90 34.1328 34.0078)",
    fill: "#F89202"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7461,
    y: 46.6182,
    width: 4.20339,
    height: 8.40678,
    transform: "rotate(90 46.7461 46.6182)",
    fill: "#F89202"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 50.8213,
    width: 4.20339,
    height: 8.40678,
    fill: "#F89202"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7266,
    y: 17.1943,
    width: 4.20339,
    height: 8.40678,
    transform: "rotate(90 25.7266 17.1943)",
    fill: "#FFB800"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3398,
    y: 29.8047,
    width: 4.20339,
    height: 8.40678,
    transform: "rotate(90 38.3398 29.8047)",
    fill: "#FFB800"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9492,
    y: 42.415,
    width: 4.20339,
    height: 8.40678,
    transform: "rotate(90 50.9492 42.415)",
    fill: "#FFB800"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7266,
    y: 12.9912,
    width: 4.20339,
    height: 4.20339,
    transform: "rotate(90 25.7266 12.9912)",
    fill: "#FDFBFB"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 29.9336,
    y: 8.78711,
    width: 8.40678,
    height: 4.20339,
    transform: "rotate(90 29.9336 8.78711)",
    fill: "#FFB800"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 29.9336,
    y: 50.8213,
    width: 4.20339,
    height: 8.40678,
    fill: "#190D11"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1172,
    y: 29.8047,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3203,
    y: 25.6016,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5234,
    y: 34.0078,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 42.415,
    width: 4.20339,
    height: 8.40678,
    fill: "#190D11"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5234,
    y: 29.8047,
    width: 8.40678,
    height: 4.20339,
    fill: "#190D11"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5234,
    y: 21.3975,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 29.9336,
    y: 25.6016,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 25.6016,
    width: 4.20339,
    height: 4.20339,
    fill: "#FDFBFB"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7461,
    y: 38.2109,
    width: 4.20339,
    height: 4.20339,
    fill: "#FDFBFB"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 42.543,
    y: 38.2109,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7266,
    y: 17.1943,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 29.9336,
    y: 12.9912,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 29.9336,
    y: 21.3975,
    width: 8.40678,
    height: 4.20339,
    fill: "#190D11"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 42.543,
    y: 34.0078,
    width: 8.40678,
    height: 4.20339,
    fill: "#190D11"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3398,
    y: 17.1943,
    width: 8.40678,
    height: 4.20339,
    fill: "#190D11"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9492,
    y: 29.8047,
    width: 8.40678,
    height: 4.20339,
    fill: "#190D11"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7461,
    y: 21.3975,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 59.3555,
    y: 34.0078,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 42.543,
    y: 25.6016,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1523,
    y: 38.2109,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3398,
    y: 29.8047,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9492,
    y: 42.415,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 34.0078,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7461,
    y: 46.6182,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1523,
    y: 46.6182,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7461,
    y: 55.0254,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 59.3555,
    y: 50.8213,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9492,
    y: 59.2285,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1523,
    y: 59.2285,
    width: 4.20339,
    height: 4.20339,
    fill: "#767266"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 59.3555,
    y: 63.4316,
    width: 4.20339,
    height: 4.20339,
    fill: "#767266"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5586,
    y: 67.6348,
    width: 4.20339,
    height: 4.20339,
    fill: "#767266"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 67.7617,
    y: 67.6348,
    width: 4.20339,
    height: 4.20339,
    fill: "#BDB69F"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5586,
    y: 55.0254,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1523,
    y: 63.4316,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 67.7617,
    y: 59.2285,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 71.9648,
    y: 63.4316,
    width: 4.20339,
    height: 8.40678,
    fill: "#190D11"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5586,
    y: 76.042,
    width: 4.20339,
    height: 8.40678,
    transform: "rotate(-90 63.5586 76.042)",
    fill: "#190D11"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 59.3555,
    y: 67.6348,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 29.9336,
    y: 38.2109,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 42.543,
    y: 50.8213,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7266,
    y: 42.415,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3398,
    y: 55.0254,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5234,
    y: 46.6182,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 59.2285,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 34.1328,
    y: 8.78711,
    width: 4.20339,
    height: 4.20339,
    fill: "#190D11"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7266,
    y: 4.58398,
    width: 8.40678,
    height: 4.20339,
    fill: "#190D11"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 8.91406,
    y: 17.1943,
    width: 4.20339,
    height: 8.40678,
    fill: "#190D11"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 4.71094,
    y: 25.6016,
    width: 4.20339,
    height: 8.40678,
    fill: "#190D11"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 0.507812,
    y: 4.58398,
    width: 4.20339,
    height: 8.40678,
    fill: "#190D11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleOldMemberIcon);
export default __webpack_public_path__ + "static/media/role_oldMember_icon.06f227795ae519a89df97fcea01079a1.svg";
export { ForwardRef as ReactComponent };